import React, { useEffect } from 'react';
import { Box, Alert, AlertTitle, styled, Card, CardContent } from '@mui/material';
import PageContainer from 'src/components/container/PageContainer';
import AuthLogin from '../authForms/AuthLogin';
import backEdited from 'src/assets/images/backgrounds/login back/editedBack3.png';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectErrorMessage,
  clearMessages,
  selectSuccessMessage,
} from 'src/store/auth/UserAuthSlice';
// import Footer from '../../../components/Footer';
import Spinner from 'src/views/spinner/Spinner';

const Login = () => {
  const errorMessage = useSelector(selectErrorMessage);
  const successMessage = useSelector(selectSuccessMessage);

  const [loading, setLoading] = React.useState(false);

  const dispatch = useDispatch();

  const handleCloseMessages = () => {
    dispatch(clearMessages());
  };

  const StyledBox = styled(Box)(({ theme }) => ({
    // boxShadow: theme.shadows[8],
    padding: '2px',
    cursor: 'pointer',
    justifyContent: 'center',
    display: 'flex',
    transition: '0.1s ease-in',
    // border: '1px solid rgba(145, 158, 171, 0.12)',
    '&:hover': {
      transform: 'scale(1.05)',
    },
  }));

  React.useEffect(() => {
    let timer = null;

    if (successMessage) {
      timer = setTimeout(() => {
        if (successMessage) {
          dispatch(clearMessages());
        }
      }, 1000);
    }
    if (errorMessage) {
      timer = setTimeout(() => {
        if (errorMessage && errorMessage === 'Log Out Successfully') {
          dispatch(clearMessages());
        }
      }, 2000);
    }

    return () => clearTimeout(timer);
  }, [dispatch, errorMessage, successMessage]);

  useEffect(() => {
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    return () => {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    };
  }, []);

  return (
    <div>
      <PageContainer title="Login" description="this is Login page">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100vh',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              flexGrow: 1,
              position: 'relative',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              '&:before': {
                content: '""',
                // background: 'radial-gradient(#d2f1df, #d3d7fa, #bad8f4)',
                backgroundSize: '400% 400%',
                animation: 'gradient 15s ease infinite',
                position: 'absolute',
                top: 0,
                left: 0,
                height: '100%',
                width: '100%',
                opacity: '0.3',
              },
            }}
          >
            <img
            src={backEdited}
            alt="bg"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              position: 'absolute',
            }}
          />
            {loading ? (
              <Spinner />
            ) : (
              <Card
                sx={{
                  position: 'relative',
                  maxWidth: '100%',
                  width: {
                    xs: '90%',
                    sm: '60%',
                    md: '60%',
                    lg: '550px',
                  },
                  zIndex: 2,
                  backdropFilter: 'blur(18px)',
                  WebkitBackdropFilter: 'blur(18px)',
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  // mt: '-170px',
                }}
              >
                <CardContent>
                  <AuthLogin
                    title=" "
                    subtext="Compliance Management System"
                    loading={loading}
                    setLoading={setLoading}
                  />
                </CardContent>
              </Card>
            )}
          </Box>

          {errorMessage && (
            <Box
              position="absolute"
              top={0}
              left="25%"
              transform="translateX(-50%)"
              mt={2}
              zIndex={9999}
              sx={{ width: '50%' }}
            >
              <Alert severity="error" onClose={handleCloseMessages}>
                <AlertTitle>
                  {errorMessage === 'Log Out Successfully' ? 'Success' : 'Error'}
                </AlertTitle>
                {errorMessage}
              </Alert>
            </Box>
          )}

          {successMessage && (
            <Box
              position="absolute"
              top={0}
              left="25%"
              transform="translateX(-50%)"
              mt={2}
              zIndex={9999}
              sx={{ width: '50%' }}
            >
              <Alert severity="success" onClose={handleCloseMessages}>
                <AlertTitle>Success</AlertTitle>
                {successMessage}
              </Alert>
            </Box>
          )}

            {/* <Footer /> */}
          <Box sx={{ flexShrink: 0 }}>
          </Box>
        </Box>
      </PageContainer>
    </div>

    // <PageContainer title="Login" description="this is Login page">
    //   <Grid container spacing={0} sx={{ overflowX: 'hidden', height: '100vh' }}>
    //     <Grid
    //       item
    //       xs={12}
    //       sm={12}
    //       lg={7}
    //       xl={8}
    //       sx={{
    //         position: 'relative',
    //         display: {
    //           xs: 'none', // Hide on extra-small screens
    //           lg: 'block', // Show from large screens upwards
    //         },
    //         '&:before': {
    //           content: '""',
    //           background: 'radial-gradient(#d2f1df, #d3d7fa, #bad8f4)',
    //           backgroundSize: '400% 400%',
    //           animation: 'gradient 15s ease infinite',
    //           position: 'absolute',
    //           height: '100%',
    //           width: '100%',
    //           opacity: '0.3',
    //         },
    //       }}
    //     >
    //       <Box position="relative" height="100%">
    //         <Box
    //           alignItems="center"
    //           justifyContent="center"
    //           height="100%"
    //           sx={{
    //             display: {
    //               xs: 'none',
    //               lg: 'flex',
    //             },
    //           }}
    //         >
    //           <img
    //             src={backEdited}
    //             alt="bg"
    //             style={{
    //               width: '100%',
    //               height: '100%',
    //               objectFit: 'cover',
    //             }}
    //           />
    //         </Box>
    //       </Box>
    //     </Grid>

    //     <Grid
    //       item
    //       xs={12} // Full width on extra-small screens
    //       lg={5} // Only take the remaining width on larger screens
    //       xl={4}
    //       display="flex"
    //       justifyContent="center"
    //       alignItems="center"
    //       sx={{ height: '100%' }}
    //     >
    //       <Box p={4} sx={{ width: '90%' }}>
    //         <Stack
    //           direction={'row'}
    //           gap={2}
    //           my={2}
    //           sx={{ mx: 2, position: 'absolute', top: '0', right: '0' }}
    //         >
    //           <Tooltip
    //             title={`Change color scheme to ${
    //               customizer.activeMode === 'light' ? 'Dark' : 'Light'
    //             }`}
    //             arrow
    //           >
    //             <Box
    //               onClick={() =>
    //                 dispatch(setDarkMode(customizer.activeMode === 'light' ? 'dark' : 'light'))
    //               }
    //               display="flex"
    //               gap={1}
    //             >
    //               {customizer.activeMode === 'light' ? (
    //                 <Lottie
    //                   animationData={SunModeAnimation}
    //                   loop
    //                   autoplay
    //                   style={{ width: '60px', height: '60px' }}
    //                 />
    //               ) : (
    //                 <Lottie
    //                   animationData={MoonModeAnimation}
    //                   loop
    //                   autoplay
    //                   style={{ width: '60px', height: '60px' }}
    //                 />
    //               )}
    //             </Box>
    //           </Tooltip>
    //         </Stack>
    //         <AuthLogin
    //           title="Welcome to "
    //           subtext={
    //             <Typography
    //               variant="subtitle1"
    //               color="textSecondary"
    //               mb={1}
    //               style={{ textAlign: 'center' }}
    //             >
    //               Compliance Management System
    //             </Typography>
    //           }
    //         />
    //       </Box>
    //     </Grid>

    //     {errorMessage && (
    //       <Box
    //         position="absolute"
    //         top={0}
    //         right={0}
    //         mr={2}
    //         mt={2}
    //         zIndex={9999}
    //         sx={{ width: '300px' }}
    //       >
    //         <Alert severity="error" onClose={handleCloseMessages}>
    //           <AlertTitle>Error</AlertTitle>
    //           {errorMessage}
    //         </Alert>
    //       </Box>
    //     )}

    //     {successMessage && (
    //       <Box
    //         position="absolute"
    //         top={0}
    //         right={0}
    //         mr={2}
    //         mt={2}
    //         zIndex={9999}
    //         sx={{ width: '300px' }}
    //       >
    //         <Alert severity="success" onClose={handleCloseMessages}>
    //           <AlertTitle>Success</AlertTitle>
    //           {successMessage}
    //         </Alert>
    //       </Box>
    //     )}
    //   </Grid>
    // </PageContainer>
  );
};

export default Login;
